<template>
    <el-row style="margin: 30px;">
        <img style="width: 200px; height: 58px; " src='../../assets/logo.png' />
    </el-row>
    <div class="main">
        <h1 style="margin-top: 10%;">分子医学检验系统</h1>
        <div class="contain">
<!--            <h1 v-if="message">消息:{{ message }}</h1>-->
            <el-form style="max-width: 350px;" label-width="auto" :model="dataForm" :rules="rules" ref="dataForm">
<!--                <el-form-item label="用户类型：" prop="user_type" name="user_type" type="text">-->
<!--                    <el-select v-model="dataForm.user_type" style="width: 240px" placeholder="-&#45;&#45;请选择-&#45;&#45;" clearable>-->
<!--                        <el-option label="实验室" value="Admin"></el-option>-->
<!--                        <el-option label="代理商" value="Agent"></el-option>-->
<!--                        <el-option label="医院" value="Hospital"></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="用户账号：" prop="user_account" name="user_account" type="text">
                    <el-input v-model="dataForm.user_account" placeholder="请输入用户名" clearable></el-input>
                </el-form-item>

                <el-form-item label="用户密码：" prop="user_password" name="user_password" type="password">
                    <el-input v-model="dataForm.user_password" placeholder="请输入密码" clearable show-password></el-input>
                </el-form-item>

                <el-form-item label="验证码：" prop="verificationCode">
                    <div style="display: flex; gap:10px;">
                        <el-input style="height: 32px;" v-model="dataForm.verificationCode" placeholder="请输入验证码" clearable></el-input>
                        <SIdentify @click="refreshCode()" :identifyCode="identifyCode"></SIdentify>
                    </div>
                </el-form-item>

            </el-form>
            <el-row class="div-row">
                <el-button class="login-button" v-on:click="onLogin" style="width: 160px; ">登录</el-button>
                <el-button class="clear-button" v-on:click="onClear" style="width: 160px;">清除</el-button>
            </el-row>
        </div>


    </div>
  <el-divider border-style="double" />
<!--  <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2025115609号</a>-->
  <div class="footer">

<!--    <h1> </h1>-->

<!--    <div class="links">...其他链接...</div>-->
    <div class="copyright">
<!--      <span>© 2025 上海添蔚医药科技有限公司</span>-->
      <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2025115609号</a>
    </div>
  </div>
</template>

<script>
import httptool from "@/http/index";
import SIdentify from '@/components/sIdentify.vue'
import usePermissionStore from "@/store/modules/permission";
export default {
    name: "Login",
    components: {
        SIdentify
    },
    data() {
        return {
            identifyCode: "",
            identifyCodes: "0123456789",
            // message: "",
            dataForm: {
                // user_type: '',
                user_account: '',
                user_password: '',
                verificationCode: ''
            },
            rules: {
                // user_type: [
                //     { required: true, message: '请选择角色', trigger: 'change' }
                // ],
                user_account: [
                    { required: true, message: '请输入用户账号', trigger: 'blur' }
                ],
                user_password: [
                    { required: true, message: '请输入用户密码', trigger: 'blur' }
                ],
                verificationCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { validator:this.checkCode, trigger:'change' }
                ],
            }
        }
    },
    methods: {
        // onLogin() {
        //     this.$refs.dataForm.validate(valid => {
        //         if (valid) {
        //             // 执行提交操作
        //             if (this.dataForm.name == "123456" && this.dataForm.password == "123456") {
        //                 this.$router.push('/Tab1Content');
        //             }
        //             else
        //                 console.log('用户名或密码错误');
        //         } else {
        //             this.$message.warning('请填写完整');
        //         }
        //     });
        // },

        async onLogin() {
            try {
                await this.$refs.dataForm.validate(); // 执行表单验证
                const formData = {

                    "user_type": this.dataForm.user_type,
                    "user_account": this.dataForm.user_account,
                    "user_password": this.dataForm.user_password
                };

                // 发送POST请求
                const response = await httptool.post(
                    // 'http://192.168.8.155:8000/login/',
                    'login/',
                    // querystring.stringify(formData),
                    formData,
                    {
                        // headers:{
                        // "content-type": this.dataForm.user_type,
                        // },
                        // params:{
                        // "123":"123"
                        // }
                    }
                ).then(res=> {
                    if (res.data['flag'] === true) {
                        this.$store.state.user_account = this.dataForm.user_account,
                        this.$store.state.user_type = res.data['user_type'],
                        this.$store.state.is_login = "true",
                        this.$store.state.user_role = res.data['user_role'],
                //         this.$store.state.user_role["menu"] = ["TestingApplication", "SampleInformation", "ReportPackageRecord", "ReturningSamples", "ReturningSamplesRecord", "ExpressManagement",
                // "CompoundQuery", "ReportQuery", "SampleBoxApplication", "SampleBoxRecord", "BarcodeDatabase", "BasicInformation", "User",
                // "RightsManage", "SubmissionDepartment", "SubmissionPhysicians", "DepartmentInformation", "UserManage", "Roles", "TestBase", "TestProjects", "ProjectSeries", "SampleType", "Agent",
                // "Hospital", "SampleBoxApplicationInfo", "BarcodeLibrary", "ReturnBagInfo", "SubjectSampleInfo", "SampleHandoverForm",
                // "GeneticDataImport", "ReportFileUpload", "ReportRegeneration", "ScanCodeImport", "ComQuery",
                // "MonthlyStatistics", "ReportQuery",]
                //         this.$store.state.user_role["button"] = ["add", "delete", "edit", "query"]
                        console.log("this.$store.state", this.$store.state),
                        // sessionStorage.setItem("is_login", res.data['flag']),
                        // console.log("sessionStorage", sessionStorage),
                        this.$router.push({path: '/home'});
                    } else {
                        this.$message.warning(res.data['message']);
                    }
                    this.message = res.data['message'];
                    console.log(this.message);
                }).catch(error=>{
                    console.log(error);             //本地错误
                    console.log(error.response);    //服务端错误
                });
            } catch (error) {
                console.error('登录出错：', error);
            }
        },
        onClear() {
            this.dataForm.user_type = '';
            this.dataForm.user_account = '';
            this.dataForm.user_password = '';
            this.dataForm.verificationCode = '';
        },

        refreshCode() {//
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        randomNum(min, max) {
            max = max + 1
            return Math.floor(Math.random() * (max - min) + min)
        },
        // 随机生成验证码字符串
        makeCode(data, len) {
            for (let i = 0; i < len; i++) {
                this.identifyCode += data[this.randomNum(0, data.length - 1)]
            }
        },
        checkCode(rule, value, callback){
            if (value === this.identifyCode) {
                callback();
            } else {
                callback(new Error('验证码不正确'));
            }
        }


    },
    mounted() {
        this.refreshCode();
    }
}
</script>

<style scoped>
.main {
    background: linear-gradient(to bottom, #ffffff, #aac7e3);
    height: 550px;
}

.contain {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.div-row {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
}

.copyright {
  font-size: 12px;
  color: #999;
  text-align: center;
  line-height: 1.6;
}

.copyright a {
  margin-left: 10px; /* 与版权信息间隔 */
}
</style>
